/**
 * Returns the object if condition is true.
 * Useful for including the object conditionally, like this:
 *
 *    {
 *      ...objectAddIf(editor.pluginEnabled(PLUGIN), {})
 *    }
 *
 * @param {Boolean} condition - condition that needs to return the object
 * @param {Object} obj - object to be returned
 */
export function objectAddIf(condition, obj) {
  if (condition) {
    return obj
  } else {
    return {}
  }
}
